import { ChangeEvent, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import SignupContext from '../../store/signup-context';
import FormInput from '../general-components/FormInput';
import styles from './SignupForm.module.css';

const UserInfoForm: React.FC = () => {
    const { t } = useTranslation();

    const {
        isIndividual,
        defaultEmail,
        errorData,
        hasRoleSelect,
        setErrorData,
        setFormData,
    } = useContext(SignupContext);

    const handleInputChange = (
        e: ChangeEvent<
            HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
        >
    ) => {
        const { name, value } = e.target;

        setErrorData({
            type: 'update',
            name,
            value: '',
        });

        setFormData({
            type: 'update',
            name,
            value,
        });
    };

    return (
        <>
            <FormInput
                type="text"
                name="name"
                label={t('signup.userInfo.form.name')}
                placeholder={t('signup.userInfo.form.placeholders.name')}
                onChange={handleInputChange}
                errorMsg={errorData.name}
            />

            <FormInput
                type="email"
                name="email"
                defaultValue={defaultEmail}
                label={t('signup.userInfo.form.email')}
                placeholder={t('signup.userInfo.form.placeholders.email')}
                onChange={handleInputChange}
                errorMsg={errorData.email}
            />
            <div className={styles.passwordContainer}>
                <FormInput
                    type="password"
                    name="password"
                    label={t('signup.userInfo.form.password')}
                    placeholder={t(
                        'signup.userInfo.form.placeholders.password'
                    )}
                    info={t('signup.userInfo.form.passwordInfo')}
                    onChange={handleInputChange}
                    errorMsg={errorData.password}
                />
                {!isIndividual && (
                    <FormInput
                        type="password"
                        name="repeatPassword"
                        label={t('signup.userInfo.form.repeatPassword')}
                        placeholder={t(
                            'signup.userInfo.form.placeholders.password'
                        )}
                        onChange={handleInputChange}
                        errorMsg={errorData.repeatPassword}
                    />
                )}
            </div>
            {hasRoleSelect && (
                <FormInput
                    tag="selectRole"
                    name="role"
                    defaultValue={'default'}
                    label={t('signup.userInfo.form.role')}
                    onSelect={handleInputChange}
                    errorMsg={errorData.role}
                    isSignup={true}
                />
            )}
        </>
    );
};

export default UserInfoForm;
